import React, { useEffect, useState } from "react";
import "../../styles/available-coupons/available-coupons.scss";
import axios from "axios";
import { Card, CircularProgress, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { FaRegCopy } from "react-icons/fa";
import AvailableCouponsMobileView from "./available-coupons-mobile-view";

const AvailableCoupons = ({ wooCommerceUnusedCoupon, loyaltyInfo, loyaltyData, couponPoints, reveiveCouponCode, woocommerceCoupons, isWcoupon }) => {
  const [activeLink, setActiveLink] = useState("REWARDS");
  //const [couponCode, setCouponCode] = useState("");
  const [selectedReward, setSelectedReward] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [isCouponcodeDisabled, setIsCouponcodesDisabled] = useState(false);
  const [woocommerceCoupon, setWoocommerceCoupon] = useState("");
  const [woocommerceCouponError, setWoocommerceCouponError] = useState("");
  const [copied, setCopied] = useState(false);
  const [isLoder, setIsLoader] = useState(false);
  const [cartValue, setCartValue] = useState("");
  const [store, setStore] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [loading, setLoading] = useState(false);
  const hasInitialTime = localStorage.getItem("initialTime") !== null;
  const combinedItems = [...loyaltyInfo.coupons.tokens, ...loyaltyInfo.coupons.rewards];

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setCartValue(searchParams.get("cart"));
    setStore(searchParams.get("storeUrl"));
  }, []);

  const backgroundColors = [
    { start: "#dbd7d7", end: "#dbd7d7" },
    { start: "#dbd7d7", end: "#dbd7d7" },
    { start: "#dbd7d7", end: "#dbd7d7" },
    { start: "#dbd7d7", end: "#dbd7d7" },
    { start: "#dbd7d7", end: "#dbd7d7" },
    { start: "#dbd7d7", end: "#dbd7d7" },
  ];

  const onButtonClick = async (value, index) => {
    //setCouponCode(value?.token_code);

    setIsLoader(true);
    setIsCouponcodesDisabled(false);
    if (activeLink === "REWARDS") {
      setSelectedReward(index);
      const conformation = window.confirm("Are you sure you want to redeem this coupon?");

      if (conformation) {
        const requestData = {
          mobile_number: loyaltyInfo.details.mobile,
          country_code: loyaltyData?.countryCode,
          points: null,
          bill_amount: cartValue,
          store_url: store,
          minimum_bill: loyaltyInfo?.minimum_bill.toString(),
          coupon_details: {
            token_valide: value?.token_valide,
            token_code: value?.token_code,
            use_limit: value?.use_limit,
            actul_used: value?.actul_used,
            name: value?.name,
            location: value?.location,
            valid_on: value?.valid_on,
            timing: value?.timing,
            valid_till: value?.valid_till,
            terms: value?.terms,
          },
        };
        try {
          const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_URL}/api/ewards/redeem-coupon`, requestData);
          setWoocommerceCoupon(response?.data?.woocommerce_coupon);
          // if (hasInitialTime) {
          //   localStorage.setItem("couponCode", response?.data?.woocommerce_coupon);
          // }
          setIsCouponcodesDisabled(true);
          reveiveCouponCode(true);
          woocommerceCoupons(true);
          setWoocommerceCouponError("");
          setIsLoader(false);
        } catch (error) {
          setWoocommerceCouponError(error?.response?.data?.resultMessage?.en);
          console.log(error);
          setIsLoader(false);
        }
      }
      if (!conformation) {
        setIsLoader(false);
      }
    } else if (activeLink === "TOKENS") {
      setSelectedToken(index);
      //setCouponCode(value?.token_code);
      setIsLoader(false);
    }
  };

  const handleChange = (event, newValue) => {
    setActiveLink(newValue === 0 ? "REWARDS" : "TOKENS");
  };
  const handleCopyClick = () => {
    const input = document.createElement("input");
    input.style.position = "fixed";
    input.style.opacity = 0;
    input.value = woocommerceCoupon;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(input);
    setCopied(true);
    setTimeout(() => setCopied(false), 4000);
  };
  const handleCopyClick1 = (value) => {
    setWoocommerceCoupon(value);
    setCopied(true);

    wooCommerceUnusedCoupon(true);
    const input = document.createElement("input");
    input.style.position = "fixed";
    input.style.opacity = 0;
    input.value = value;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(input);
  };

  // useEffect(() => {
  //   if (woocommerceCoupon) {
  //     localStorage.setItem("couponCode", woocommerceCoupon);
  //   }
  // }, [woocommerceCoupon]);

  useEffect(() => {
    if (woocommerceCoupon) {
      woocommerceCoupons(true);
    }
  }, [woocommerceCoupon, woocommerceCoupons]);

  const onClickApplyPromoCode = async () => {
    if (promoCode === "") return;
    const payload = {
      mobile_number: loyaltyInfo.details.mobile,
      country_code: loyaltyData?.countryCode,
      bill_amount: cartValue,
      store_url: store,
      minimum_bill: loyaltyInfo?.minimum_bill.toString(),
      coupon_details: {
        token_code: promoCode,
      },
    };
    setLoading(true);
    setWoocommerceCouponError("");
    try {
      const response = await axios.post(`${process.env.REACT_APP_PRODUCTION_URL}/api/ewards/redeem-coupon`, payload);
      setWoocommerceCoupon(response?.data?.woocommerce_coupon);
      setIsCouponcodesDisabled(true);
      setLoading(false);
      if (hasInitialTime) {
        localStorage.setItem("couponCode", response?.data?.woocommerce_coupon);
      }
    } catch (err) {
      setLoading(false);
      console.log(err.response.data.resultMessage.en);
      setWoocommerceCouponError(err.response.data.resultMessage.en);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card className="container1" sx={{ background: "#F7F7F8" }}>
          <p style={{ fontWeight: 500, marginTop: "-30px", fontSize: "15px" }}>Enter Your Loyalty Coupon Code Here</p>
          <Card className="container2" sx={{ marginTop: 1 }}>
            <Box sx={{ width: "100%", bgcolor: "background.paper", fontFamily: "var(--font-family)" }}>
              <Tabs
                value={activeLink === "REWARDS" ? 0 : 1}
                onChange={handleChange}
                centered
                sx={{ "& .MuiTabs-indicator": { backgroundColor: "var(--primary-color)", width: "30px" } }} // Change the color of the indicator line here
              >
                <Tab label="Coupons" sx={{ textTransform: "capitalize", "&.Mui-selected": { color: "var(--primary-color)" }, fontFamily: "var(--font-family)" }} />
                <Tab label="Unused Coupons" sx={{ textTransform: "capitalize", "&.Mui-selected": { color: "var(--primary-color)" }, fontFamily: "var(--font-family)" }} />
              </Tabs>
            </Box>

            <div>
              {activeLink === "REWARDS" ? (
                loyaltyInfo?.coupons?.tokens?.length ? (
                  <div className="tokes-rewards-coupons-container">
                    {combinedItems.map((item, index) => (
                      <div key={index} className="couponradiobutton">
                        <div className="token-card">{item?.token_code}</div>
                        <div className="token-info-container">
                          <p className="tokens-info-section">{item?.name}</p>
                          <p className="tokens-info-section">Valid: {item.valid_till.split("-").reverse().join("-")}</p>
                          <p>Use_limit: {item?.use_limit}</p>
                        </div>
                        <button className={couponPoints || isCouponcodeDisabled ? "apply-button1" : "apply-button"} onClick={() => onButtonClick(item, index)} disabled={couponPoints || isCouponcodeDisabled}>
                          Apply
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ textAlign: "center", marginTop: "50px" }}>No coupons found</p>
                )
              ) : activeLink === "TOKENS" ? (
                loyaltyInfo?.shopify_code?.length ? (
                  <div className="tokes-rewards-coupons-container">
                    {loyaltyInfo.shopify_code.map((item, index) => (
                      <div key={index} className="couponradiobutton1">
                        <div
                          className="couponcodecontainer"
                          style={{
                            background: `linear-gradient(to top left, ${backgroundColors[index % backgroundColors.length].start} 50%, ${backgroundColors[index % backgroundColors.length].end} 50%)`,
                            marginBottom: "10px",
                          }}
                        >
                          <div className="coupondiscountcontainer"></div>
                          <div className="coupondiscounttext">
                            <p>{item.name}</p>
                          </div>
                        </div>
                        <div className="couponname">
                          <p className="validcoupon">{item.shopify_code}</p>
                        </div>
                        <button className="apply-button" onClick={() => handleCopyClick1(item?.shopify_code)}>
                          Copy
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ textAlign: "center", marginTop: "50px" }}>No coupons found</p>
                )
              ) : (
                <p style={{ textAlign: "center", marginTop: "40px" }}>No coupons found</p>
              )}
            </div>
          </Card>
          {isLoder && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px", marginLeft: "40px" }}>
              <CircularProgress sx={{ color: "var(--primary-color)" }} />
            </div>
          )}
          {!isLoder && (
            <div className="points-redem-container1">
              <input disabled={woocommerceCoupon} onChange={(e) => setPromoCode(e.target.value)} className="custom-textfield" />
              <button disabled={woocommerceCoupon} onClick={onClickApplyPromoCode} className={woocommerceCoupon ? "custom-button2 mobile-field" : "custom-button1 mobile-field"}>
                {loading ? <CircularProgress size={25} sx={{ color: "var(--secondary-color)" }} /> : "Apply Promo Code"}
              </button>
            </div>
          )}
          {woocommerceCoupon && !isLoder && (
            <div className="custom-textfield2">
              <p>{woocommerceCoupon}</p>
              {!copied ? <FaRegCopy onClick={handleCopyClick} style={{ marginTop: "0px", marginLeft: "30px", cursor: "pointer" }} /> : <p style={{ marginTop: "12px", marginLeft: "30px", color: "green" }}>Copied!</p>}
            </div>
          )}

          {woocommerceCouponError && <p className="error-msg">{woocommerceCouponError}</p>}
        </Card>
        <AvailableCouponsMobileView
          activeLink={activeLink}
          handleChange={handleChange}
          loyaltyInfo={loyaltyInfo}
          selectedReward={selectedReward}
          couponPoints={couponPoints}
          isCouponcodeDisabled={isCouponcodeDisabled}
          backgroundColors={backgroundColors}
          onButtonClick={onButtonClick}
          selectedToken={selectedToken}
          handleCopyClick={handleCopyClick}
          copied={copied}
          woocommerceCoupon={woocommerceCoupon}
          woocommerceCouponError={woocommerceCouponError}
          isLoder={isLoder}
          isWcoupon={isWcoupon}
          handleCopyClick1={handleCopyClick1}
          onClickApplyPromoCode={onClickApplyPromoCode}
          setPromoCode={setPromoCode}
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

export default AvailableCoupons;
